import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { SocketProvider } from "./hooks/useSocket";
import { useStore } from "./authContext/StoreContext";
import Products from "./pages/Products";

import LaamLayout from "./pages/Laam/LaamLayout";
import Laam from "./pages/Laam/Laam";
import LaamProducts from "./pages/Laam/LMProducts";
import ProductsDLM from "./pages/Laam/ProductsDLM";
import LaamOrders from "./pages/Laam/LMOrders";
import OrdersDLM from "./pages/Laam/OrdersDLM";
import ProductDetails from "./pages/ProductDetails";

import OrdersLayout from "./components/OrdersLayout";
import Orders from "./pages/Orders";
import OrdersBooking from "./pages/OrdersBooking";
import OrdersProcessing from "./pages/OrdersProcessing";
import OrdersPaid from "./pages/OrdersPay";

import Dashboard from "./Dashboard";
import Login from "./pages/auth/LoginPage";
import UserRegister from "./pages/auth/RegPage";
import Users from "./pages/auth/Users";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Logs from "./pages/Logs";

// import TraxCity from "./pages/CitiesTable";
import OrderDetails from "./pages/OrderDetails";
import Stores from "./pages/Stores";
import StoresDetails from "./pages/StoreDetails";
import StoreSaleReports from "./pages/StoreSaleReports";
import Couriers from "./pages/Couriers";
import LoadSheet from "./pages/LoadSheet";
import CourierDetails from "./pages/CourierDetails";
import Webhooks from "./pages/Webhooks";
import InventoryLogs from "./pages/InventoryLogs";
import VariantDetails from "./pages/VariantDetails";
import Clients from "./pages/admin/Clients";
import Charts from "./pages/charts";
import ChatHome from "./chat/ChatHome";
const isAuthenticated = () => {
  // You can replace this with your token check logic
  return localStorage.getItem("token") !== null;
};

// Private route component
function PrivateRoute({ element, ...rest }) {
  return isAuthenticated() ? element : <Navigate to="/login" />;
}
const getUserRole = () => {
  // This is an example; you would typically parse the token or get this data from an API
  const user = JSON.parse(localStorage.getItem("user"));

  return user?.user.role; // Example: 'admin', 'orders', 'user', etc.
};
function RoleBasedRoute({ element, allowedRoles, ...rest }) {
  const userRole = getUserRole();

  return isAuthenticated() && allowedRoles.includes(userRole) ? (
    element
  ) : (
    <Navigate to="/login" />
  );
}

function App() {
  const { selectedStore, isStoreSelected } = useStore();
  const storeID = isStoreSelected && selectedStore.id;
  return (
    <SocketProvider storeId={storeID}>
      <Router>
        <Routes>
          <Route path="/" element={<PrivateRoute element={<Dashboard />} />}>
            <Route
              path="/products"
              element={<PrivateRoute element={<Products />} />}
            ></Route>
            <Route
              path="/chart"
              element={<PrivateRoute element={<Charts />} />}
            ></Route>
            <Route
              path="/product/:id"
              element={<PrivateRoute element={<ProductDetails />} />}
            ></Route>

            <Route
              path="/variant/:sku"
              element={<PrivateRoute element={<VariantDetails />} />}
            ></Route>
            <Route
              path="/webhooks"
              element={<PrivateRoute element={<Webhooks />} />}
            ></Route>

            <Route
              path="/inventoryLogs"
              element={<PrivateRoute element={<InventoryLogs />} />}
            ></Route>
            <Route
              path="/logs"
              element={<PrivateRoute element={<Logs />} />}
            ></Route>
            <Route
              path="/stores"
              element={<PrivateRoute element={<Stores />} />}
            ></Route>
            <Route
              path="/stores/:id"
              element={<PrivateRoute element={<StoresDetails />} />}
            ></Route>
            <Route
              path="/couriers"
              element={<PrivateRoute element={<Couriers />} />}
            ></Route>
            <Route
              path="/loadsheet"
              element={<PrivateRoute element={<LoadSheet />} />}
            ></Route>
            <Route
              path="/courierdetails/:id"
              element={<PrivateRoute element={<CourierDetails />} />}
            ></Route>

            <Route
              path="/salereports/:id"
              element={<PrivateRoute element={<StoreSaleReports />} />}
            ></Route>

            <Route
              path="/orders"
              element={<PrivateRoute element={<OrdersLayout />} />}
            >
              <Route index element={<Orders />} />
              <Route path=":id" element={<OrderDetails />} />
              <Route path="processing" element={<OrdersProcessing />} />
              <Route path="booking" element={<OrdersBooking />} />
              <Route path="paid" element={<OrdersPaid />} />
            </Route>
            <Route
              path="/laam"
              element={<PrivateRoute element={<LaamLayout />} />}
            >
              <Route index element={<Navigate to="/laam/products" />} />
              <Route path="/laam/products" element={<LaamProducts />} />
              <Route path="/laam/products/:id" element={<ProductsDLM />} />
              <Route path="/laam/orders" element={<LaamOrders />} />
              <Route path="/laam/orders/:id" element={<OrdersDLM />} />
            </Route>
            <Route
              path="/chats"
              element={<PrivateRoute element={<ChatHome />} />}
            ></Route>
          </Route>

          <Route>
            <Route path="/register" element={<UserRegister />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot" element={<ForgotPassword />} />
            <Route path="/users" element={<Users />} />
          </Route>
          <Route>
            <Route path="/clients" element={<Clients />} />
          </Route>
        </Routes>
      </Router>
    </SocketProvider>
  );
}

export default App;
